import Model, { attr, belongsTo } from '@ember-data/model';

export default class PrescreenerQuestionModel extends Model {
  @belongsTo('practice') practice;

  @attr('boolean') showOnContactForm;
  @attr('boolean') showOnAppointmentForm;

  @attr() questions;
}
